import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict:true,  // 开启严格模式  确保state 中的数据只能 mutations 修改
  state:{
    //客服系统
    customerQuery: {}, //querys,页面间传递
    appId: '7facce953783dee693d96c42b6bf8c74',
    token:'',
    serverSign: { //获取选服列表时的sign
      343: '3f1dc7cdbabce8a04d3c1a2d0c111e80'
    },
    //勇者社区接口公共参数
    forumPublic: {
      formDatas: {
        gameId: 343,
        appId: '5116a9905e03749fbbd9120cc3e787f5',
        platform: 'web',
        oldSdkToken: ''
      }
    }
  },
  mutations: {
    increment(state,para) {
      state.customerQuery = para
    },
    token(state,para){
      state.token = para
    },
    forumToken(state,para){
      state.forumPublic.formDatas.oldSdkToken = para
    }
  }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js